/**
 * Shared constants for training tracks
 * These constants match the backend constants
 */

export enum DifficultyLevel {
  BEGINNER = 'beginner',
  INTERMEDIATE = 'intermediate',
  ADVANCED = 'advanced'
}

export const DIFFICULTY_LABELS: Record<DifficultyLevel, string> = {
  [DifficultyLevel.BEGINNER]: 'Beginner',
  [DifficultyLevel.INTERMEDIATE]: 'Intermediate',
  [DifficultyLevel.ADVANCED]: 'Advanced'
};

export enum PushbackLevel {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high'
}

export const PUSHBACK_LABELS: Record<PushbackLevel, string> = {
  [PushbackLevel.LOW]: 'Low (30% follow-up, accepts ≥60 score)',
  [PushbackLevel.MEDIUM]: 'Medium (60% follow-up, accepts ≥70 score)',
  [PushbackLevel.HIGH]: 'High (90% follow-up, accepts ≥80 score)'
};

export const PUSHBACK_CONFIG: Record<PushbackLevel, { followUpProbability: number; acceptanceThreshold: number }> = {
  [PushbackLevel.LOW]: {
    followUpProbability: 0.3,
    acceptanceThreshold: 60
  },
  [PushbackLevel.MEDIUM]: {
    followUpProbability: 0.6,
    acceptanceThreshold: 70
  },
  [PushbackLevel.HIGH]: {
    followUpProbability: 0.9,
    acceptanceThreshold: 80
  }
};

export const getDifficultyLabel = (difficulty: DifficultyLevel): string => {
  return DIFFICULTY_LABELS[difficulty] || difficulty;
};

export const getPushbackLabel = (level: PushbackLevel): string => {
  return PUSHBACK_LABELS[level] || level;
};
